import React from 'react';
import { useIntl } from 'react-intl';

import {
  getDatePickerFormat,
  getTimePickerFormat,
  getDateTimePickerFormat,
} from 'utils/datePickerFormat';

type DatePickerFormat = {
  dateFormat: string;
  timeFormat: string;
  dateTimeFormat: string;
};

const useDatePickerFormat = (): DatePickerFormat => {
  const { locale } = useIntl();

  return React.useMemo(
    () => ({
      dateFormat: getDatePickerFormat(locale),
      timeFormat: getTimePickerFormat(locale),
      dateTimeFormat: getDateTimePickerFormat(locale),
    }),
    [locale]
  );
};

export default useDatePickerFormat;
